import { render, staticRenderFns } from "./artists-picker.vue?vue&type=template&id=d695912c&scoped=true"
import script from "./artists-picker.vue?vue&type=script&lang=js"
export * from "./artists-picker.vue?vue&type=script&lang=js"
import style0 from "./artists-picker.vue?vue&type=style&index=0&id=d695912c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d695912c",
  null
  
)

export default component.exports